export default {
  computed: {
    panduanPa() {
      return `
      <h1 class="title green--text text-uppercase">Diterima</h1>
      <ol class="mb-5 black--text text-justify">
      <li>Nama kandidat di aplikasi <b>sama dengan semua</b> dokumen yang diunggah (unggahan dokumen lengkap), khusus Ijazah jika nama cocok sebagian bisa diterima, cth: Pakta & Surat Izin nama tertulis - <i>Dewi Anggraeni Melati</i>, tapi di Ijazah <i>Dewi Anggraeni</i> (foto ijazah vs. KTP bisa diperiksa jika sangat berbeda)</li>
      <li>Nama & NIK di Pakta Integritas dan Surat Izin/Rekomendasi cocok dengan KTP</li>
      <li>Nama sesuai sebagian, namun nomor NIK cocok antara aplikasi, pakta integritas, dan surat keterangan</li>
      <li>Semua bagian surat diisi lengkap (tidak ada yang kosong)</li>
      <li>Surat Pakta Integritas diberi ttd basah (bukan ttd elektronik) dan diberi materai 10.000</li>
      <li>Surat izin/rekomendasi diberi ttd basah (Kadis atau atas nama Kadis)</li>
      <li>Surat izin <b>wajib</b> diberi cap instansi (jika peserta berasal dari instansi)</li>
      <li>
      Khusus unsur <b>Kepala sekolah dan wakil kepala sekolah, manajemen sekolah, dan guru dari sekolah yang mengembangkan kurikulum satuan pendidikan secara mandiri dan atau menggunakan kurikulum internasional</b>, kandidat diterima jika tertera informasi kurikulum mandiri atau internasional pada isian CV contoh:
      <div>
      <ol type="a">
        <li>IB</li>
        <li>Cambridge</li>
        <li>Montessori</li>
        <li>Pearson</li>
        <li>Sekolah Alam</li>
        <li>International Primary Curriculum</li>
        <li>Singaporean Primary School Curriculum</li>
        <li>Waldorf</li>
        <li>Reggio Emilia</li>
        <li>High Scope</li>
        <li><b>Sekolah Negeri:</b> SMANBARA, SMAN 17 Palembang, SMANU MH Thamrin, SMAN 1 Palembang, SMAN SUMSEL, dll.</li>
      </ol>
      </div>
      </li>
      <li>Foto/Pindai KTP yang diunggah merupakan KTP asli. Jika tidak ada KTP, dapat diganti dengan surat keterangan dari kelurahan/disdukcapil yang masih berlaku</li>
      </ol>

      <h1 class="title warning--text text-uppercase">Diterima dengan Perbaikan</h1>
      <ol class="mb-5 black--text text-justify">
      <li>Nama/NIK sesuai dengan aplikasi, namun Nama atau NIK di Pakta Integritas/Surat Izin tidak tepat sebagian dengan KTP yang diunggah. (<b>Ket Aplikasi</b>: Nama/NIK tidak sesuai di dokumen unggahan) <br />(toleransi perbedaan diijinkan 1 digit di angka 0 dan 1 digit untuk angka lainnya)</li>
      <li>Sebagian isian penting Pakta Integritas/Surat Izin/Surat rekomendasi tidak lengkap sebagian (contoh: NIK kosong, no telp, email pribadi kosong, dll) (<b>Ket Aplikasi</b>: Isian Pakta Integritas/Surat Izin/Surat rekomendasi tidak lengkap)</li>
      <li>Surat izin ditandatangani tapi tidak dibubuhi cap basah instansi atau Surat dicap basah tapi tanda tangan atasan tidak ada (khusus yg berasal dari instansi) (<b>Ket di aplikasi</b>: Surat izin yang diunggah tidak ada cap basah/tanda tangan)</li>
      <li>Surat rekomendasi tidak ada tanda tangan dari pemberi rekomendasi (<b>Ket di aplikasi</b>: Surat rekomendasi yang diunggah tidak ada tanda tangan basah)</li>
      <li>Pakta integritas tidak dibubuhi materai (<b>Ket di aplikasi</b> : Mohon unggah ulang Pakta Integritas dengan membubuhi materai)</li>
      <li>KTP yang diunggah tidak terlihat jelas, hasil pindai kurang baik atau Foto/pindai KTP yang diunggah bukan KTP asli (<b>Ket di aplikasi</b> : Mohon unggah ulang KTP asli. Jika KTP asli Bapak/Ibu hilang, mohon mengunggah Surat Keterangan dari POLRI)</li>
      <li><b>Lain-lain (sebutkan)</b> → di sistem muncul isian berupa text box</li>
      <li><b>Khusus kandidat akselerasi/cadangan:</b> Mohon dapat memperbaiki berkas sesuai catatan sebelum tanggal 8 Juli 2022</li>
      </ol>

      <h1 class="title error--text text-uppercase">Ditolak</h1>
      <ol class="black--text text-justify">
      <li>Unggahan dokumen tidak cocok seperti persyaratan. (<b>Contoh</b>: salah satu unggahan adalah foto ruangan)</li>
      <li>Nama kandidat di aplikasi <b>tidak sama keseluruhan</b> dengan semua dokumen yang diunggah. (<b>Ket Aplikasi</b>: Nama tidak cocok dengan dokumen)</li>
      <li>Tanda tangan di Surat Pakta Integritas bukan ttd asli / bukan ttd elektronik. (<b>Ket Aplikasi</b>: Ttd dokumen tidak sesuai persyaratan)</li>
      <li>Tanda tangan di Surat izin/Surat Rekomendasi bukan ttd asli // bukan ttd elektronik. (<b>Ket Aplikasi</b>: Ttd dokumen tidak sesuai persyaratan)</li>
      <li>Cap instansi pada surat rekomendasi <b>tidak sama</b> dengan instansi peserta fasilitator (khusus bagi yg berasal dari instansi, <b>tdk berlaku</b> untuk unsur Praktisi/Konsultan) <br /> <i>(Unsur praktisi/konsultan akan mengunggah surat rekomendasi, mohon diperhatikan agar surat yg diunggah tidak diberikan dari instansi dinas/pemerintahan, jika kop, stempel berasal dari dinas/pemerintahan untuk ditolak)</i></li>
      <li>Khusus unsur <b>Kepala sekolah dan wakil kepala sekolah, manajemen sekolah, dan guru dari sekolah yang mengembangkan kurikulum satuan pendidikan secara mandiri dan atau menggunakan kurikulum internasional</b>, jika di isian CV <b>kurikulum sekolah tidak sesuai dengan syarat fasilitator. (Ket. Aplikasi</b>: Asal satuan Pendidikan bukan satuan yang menerapkan kurikulum secara mandiri atau menggunakan kurikulum internasional)</li>
      <li>Pengalaman melakukan pendampingan <b>di bawah</b> 2 tahun (<b>Ket Aplikasi</b> : Pengalaman melakukan pendampingan di bawah 2 tahun)</li>
      <li><b>Lain-lain (sebutkan)</b> → di sistem muncul isian berupa text box</li>
      </ol>
      `;
    },

    panduanKs() {
      return `
      <h1 class="title green--text text-uppercase">Diterima</h1>
      <ul>
      <li>Nama kandidat di aplikasi <b>sama</b> dengan semua dokumen yang diunggah</li>
      <li>Nama & NIK di semua dokumen <b>cocok</b> dengan KTP</li>
      <li><b>Nama sesuai sebagian</b>, namun nomor NIK cocok antara aplikasi dan semua dokumen</li>
      <li>
      NIK berbeda sebagian dengan KTP namun nama & tanggal lahir sesuai antara aplikasi dan KTP yang diunggah. 
      <i>Catatan : <b>Mohon memperbaiki nomor NIK Anda di dapodik</b></i>
      </li>
      <li>KTP yang diunggah cocok dengan nama kandidat dan terlihat jelas</li>
      <li>Foto/Pindai KTP yang diunggah adalah KTP asli & jelas terbaca</li>
      <li>Semua bagian surat <b>diisi lengkap</b> (tidak ada yang kosong)</li>
      <li>Semua dokumen yang diunggah merupakan dokumen <b>asli</b> (bukan fotokopi) dan terlihat jelas</li>
      <li>Pakta Integritas <b>ditandatangani di atas materai 10.000</b></li>
      <li>
        Surat Dukungan memiliki kop surat resmi dari Dinas Pendidikan:
        <ol style="list-style: lower-alpha">
        <li>
        <b>KS Satuan Pendidikan Negeri:</b><br>
        <b>ditandatangani diatas materai 10.000</b> oleh Kepala Dinas Pendidikan/KADISCAB/Pejabat yang ditunjuk 
        (dgn <b>jabatan minimal Kepala Bidang</b>) <b>dan dibubuhi cap/stempel basah</b> dari Dinas Pendidikan/intansi terkait
        </li>
        <li>
        <b>KS Swasta:</b><br>
        <b>ditandatangani diatas materai</b> oleh Kepala Dinas Pendidikan/KADISCAB/Pejabat yang ditunjuk (dgn 
        <b>jabatan minimal Kepala Bidang</b>) 
        dan <b>ditandatangani</b> oleh Ketua Yayasan <b>serta dibubuhi cap/stempel basah</b> pada kedua kolom tandatangan tsb
        </li>
        </ol>
      </li>
      </ul>

      <h1 class="title warning--text text-uppercase">Diterima dengan Perbaikan</h1>
      <ul>
      <li>
      Nama atau  NIK di aplikasi <b>tidak tepat sebagian (kurang lengkap)</b> dengan dokumen yang diunggah. 
      <i><b>Catatan: Mohon memperbaiki Nama/NIK yang terdapat di dalam surat dukungan/Pakta integritas</b></i>
      </li>
      <li>KTP yang diunggah tidak terlihat jelas, hasil pindai kurang baik (Terutama data Nama, NIK, & Tanggal Lahir tidak terbaca/tidak jelas)</li>
      <li>Foto/Pindai KTP yang diunggah <b>bukan KTP asli (dilihat dari kesesuaian NIK)</b></li>
      <li>Sebagian isian surat dukungan <b>tidak lengkap</b> (contoh: NIK kosong, nomor hp kosong, email pribadi kosong)</li>
      <li>
      Terdapat beberapa poin/pasal dalam pakta integritas atau surat dukungan yang dihilangkan. 
      <i><b>Catatan : Mohon mengunggah pakta integritas/ surat dukungan sesuai dengan format yang benar</b></i>
      </li>
      <li>
       Pakta integritas ditandatangani <b>namun tidak diberi materai</b> atau tidak dibubuhi tanda tangan dan tidak dibubuhi materai.
       <i><b>Catatan : Pakta integritas wajib dibubuhi tanda tangan & materai</b></i>
       </li>
      <li>
      Surat Dukungan Atasan
      <ol style="list-style: lower-alpha">
        <li>
          <b>Kepala Sekolah Negeri:</b>
          <ul>
          <li>Ditandatangani dan bermaterai tapi tidak dibubuhi cap basah Dinas</li>
          <li>Ditandatangani dan dicap basah tetapi tidak dibubuhi materai</li>
          <li>Dicap basah tapi tanda tangan tidak ada</li>
          <li>Tidak memiliki kop surat resmi dari dinas pendidikan</li>
          <li>Kolom tanda tangan kosong (tidak ada tanda tangan, materai, dan cap basah)</li>
          </ul>
        </li>
        <li>
          <b>Kepala Sekolah Swasta:</b>
          <ul>
          <li>Tidak ada materai pada kolom ttd dinas</li>
          <li>Hanya ditandatangani oleh salah satu pihak</li>
          <li>Tidak dibubuhi cap/stempel basah dari dinas pendidikan/yayasan</li>
          <li>Tidak memiliki kop surat resmi dari dinas pendidikan</li>
          <li>Kolom tanda tangan kosong (tidak ada tanda tangan, materai, dan cap basah)</li>
          </ul>
        </li>
      </ol>
      </li>
      <li>Tandatangan atau cap di surat dukungan/pakta integritas <b>tidak asli/dalam bentuk gambar</b> (terlihat seperti dicrop/ditempel)</li>
      <li>Lain-lain (sebutkan) → di sistem muncul isian berupa text box</li>
      </ul>

      <h1 class="title error--text text-uppercase">Ditolak</h1>
      <ul>
      <li>Nama pada dokumen unggahan (KTP/Pakta Integritas/Surat Dukungan) <b>tidak cocok</b> secara keseluruhan dengan nama yang tertera pada aplikasi</li>
      <li>Nama atau  NIK di dokumen unggahan <b>tidak sama secara keseluruhan</b> dengan KTP yg dilampirkan</li>
      <li>Surat Dukungan tidak diisi/kosong</li>
      <li>KTP yang diunggah tidak cocok/berbeda secara keseluruhan dengan identitas di aplikasi dan dokumen unggahan lain (pakta integritas/surat dukungan)</li>
      <li>Dokumen unggahan tidak sesuai contoh atau unggahan berisi dokumen lain selain Pakta Integritas, Surat Dukungan dan KTP</li>
      <li><b>Tahun kelahiran di bawah tahun 1967 (Jika kelahiran 1966, 1965, dst ditolak)</b></li>
      <li><b>Terdeteksi sebagai asesor Program Guru Penggerak/Program Sekolah Penggerak, pengajar praktik/fasilitator PGP, fasilitator PSP</b></li>
      <li>Lain-lain (sebutkan) → di sistem muncul isian berupa text box</li>
      </ul>
      `;
    },
  },
};
